// extracted by mini-css-extract-plugin
export var checkbox = "_3s-0";
export var circle = "_3s-3";
export var horizontalContainer = "_3s-7";
export var sm = "_3s-5";
export var switch0 = "_3s-2";
export var switchDisabled = "_3s-8";
export var switchEnabled = "_3s-1";
export var textSwitchContainer = "_3s-9";
export var textSwitchOption = "_3s-a";
export var textSwitchOptionSelected = "_3s-b";
export var verticalContainer = "_3s-6";
export var xs = "_3s-4";